import Savings1 from "../../../assets/our work/carousel/Savings1.png";
import Savings2 from "../../../assets/our work/carousel/Savings2.png";
import Microbusiness1 from "../../../assets/our work/carousel/Microbusiness1.png";
import Microbusiness2 from "../../../assets/our work/carousel/Microbusiness2.png";
import Patrec1 from "../../../assets/our work/carousel/Patrec1.png";
import Patrec2 from "../../../assets/our work/carousel/Patrec2.png";
import Eco1 from "../../../assets/our work/carousel/Eco1.png";
import Eco2 from "../../../assets/our work/carousel/Eco2.png";
import SIMTalent1 from "../../../assets/our work/carousel/SIMTalent1.png";
import SIMTalent2 from "../../../assets/our work/carousel/SIMTalent2.png";
import ApplesOrangesMockup1 from "../../../assets/our work/carousel/ApplesOrangesMockup1.png";
import ApplesOrangesMockup2 from "../../../assets/our work/carousel/ApplesOrangesMockup2.png";
import zido_1 from "../../../assets/our work/carousel/zido_1.png";
import zido_2 from "../../../assets/our work/carousel/zido_2.png";
import zido_3 from "../../../assets/our work/carousel/zido_3.png";
// tecnologies
import autodesk from "../../../assets/our work/technologies/savingTecnolog/autodesk.png";
import blender from "../../../assets/our work/technologies/savingTecnolog/blender.png";
import unity from "../../../assets/our work/technologies/savingTecnolog/unity.png";

import swift from "../../../assets/our work/technologies/patric/swift.png";
import rust from "../../../assets/our work/technologies/patric/rust.png";
import kotlin from "../../../assets/our work/technologies/patric/kotlin.png";
import shopyfy from "../../../assets/our work/technologies/patric/shopyfy.png";
import android from "../../../assets/our work/technologies/patric/android.png";
import laravel from "../../../assets/our work/technologies/patric/laravel.png";
import bigCom from "../../../assets/our work/technologies/patric/bigCom.png";
import react from "../../../assets/our work/technologies/patric/react.png";
import node from "../../../assets/our work/technologies/patric/node.png";
import googlePlay from "../../../assets/our work/googlePlay.png";
import AppStore from "../../../assets/our work/AppStore.png";
import Vatrina from "../../../assets/our work/Vatrina.png";
import Vatrina2 from "../../../assets/our work/Vatrina2.png";
import zagg from "../../../assets/our work/zagg..png";
import roboost from "../../../assets/our work/roboost.png";
import Savvy from "../../../assets/our work/Savvy.png";
import abardo from "../../../assets/our work/abardo.png";
import jawalat1 from "../../../assets/our work/jawalat1.png";
import jawalat2 from "../../../assets/our work/jawalat2.png";
import Historica from "../../../assets/our work/Historica.png";
import HistoricaR from "../../../assets/our work/historicaR.png";
import Graveler from "../../../assets/our work/Graveler.png";
import aiSports from "../../../assets/our work/aiSports.png";
import Wheels from "../../../assets/our work/Wheels.png";
import rabbit from "../../../assets/our work/rabbit.png";
import peacekeepers from "../../../assets/our work/peacekeepers.png";
import power from "../../../assets/our work/power.png";

import gam from "../../../assets/our work/gam.png";
import seeds_of_hope from "../../../assets/our work/seeds_of_hope.png";
import saqaya from "../../../assets/our work/saqaya.png";
import SAFY from "../../../assets/our work/SAFY.png";
import Saydaly from "../../../assets/our work/Saydaly.png";
import trips_large from "../../../assets/our work/trips_large.png";
import mrb_large from "../../../assets/our work/mrb_large.png";

export const contentList = [
  // ( 0 ) The Micro Business Game
  {
    projectName: "The Micro Business Game",
    partners: "DSIK - German Ministry of Economic Cooperation",
    subTitle: "Manage your juicery shop",

    client: "DSIK - German Ministry of Economic Cooperation",
    type: {
      text: "Platform",
      icon: {
        icon1: null,
        icon2: "fas fa-mobile-alt",
      },
    },
    // projectDescription: `The Micro business game is an open mobile game that aims to teach micro business fundamentals.`,
    challenge: `Transforming international Micro Business curriculum to an engaging mobile game.`,
    coverage: "50 different countries with 12 languages.",
    // approach: {
    //   text: `Designing a single player simulation game that injects the learning objectives into an interactive experience.`,
    //   points: [
    //     "Empowering on-ground training by the extra activity that is available to the audience.",
    //     "Extending and strengthening the post-training connection with the audience",
    //     "Reaching a wider audience and making DSIK’s learning objectives available to a broader target group.",
    //   ],
    // },
    globalText: [
      "The Micro business game is an open mobile game that aims to teach micro business fundamentals.",
    ],
    otherBenefits: null,
    technologies: [
      { image: unity, name: "Unity" },
      { image: blender, name: "Blender" },
      { image: autodesk, name: "Autodesk Maya", semiLarge: true },
    ],
    carousel: {
      images: [Microbusiness1, Microbusiness2],
    },
    googlePlayUrl: {
      img: googlePlay,
      url: "https://play.google.com/store/apps/details?id=com.sparkasse.thebusinessgame&gl=US",
    },
    appStoreUrl: {
      img: AppStore,
      url: "https://apps.apple.com/eg/app/the-micro-business-game/id6443647722",
    },
    url: null,
  },
  // ( 1 ) The Savings Game
  {
    projectName: "The Savings Game",
    partners: "DSIK - German Ministry of Economic Cooperation",
    client: "DSIK - German Ministry of Economic Cooperation",
    subTitle: "Manage your family household",
    type: {
      text: "Platform",
      icon: {
        icon1: null,
        icon2: "fas fa-mobile-alt",
      },
    },
    // projectDescription: `The Savings game is an open rpg mobile game that aims to teach financial literacy.`,
    challenge: ` Enhancing financial planning and saving skills through an interactive gaming experience.`,
    coverage: "50 different countries with 12 languages.",
    // approach: {
    //   text: `Designing a single player simulation game that injects the learning objectives into an interactive experience.`,
    //   points: [
    //     "Empowering on-ground training by the extra activity that is available to the audience.",
    //     "Extending and strengthening the post-training connection with the audience",
    //     "Reaching a wider audience and making DSIK’s learning objectives available to a broader target group.",
    //   ],
    // },
    globalText: [
      "The Savings game is an open rpg mobile game that aims to teach financial literacy.",
    ],
    otherBenefits: null,
    technologies: [
      { image: unity, name: "Unity" },
      { image: blender, name: "Blender" },
      { image: autodesk, name: "Autodesk Maya", semiLarge: true },
    ],
    carousel: {
      images: [Savings1, Savings2],
    },
    googlePlayUrl: {
      img: googlePlay,
      url: "https://play.google.com/store/apps/details?id=de.sparkasse.savingsgame&gl=US",
    },
    appStoreUrl: {
      img: AppStore,
      url: "https://apps.apple.com/eg/app/the-savings-game/id1583366017",
    },
    url: null,
  },
  // ( 2 ) Jawalat Al Horouf
  {
    projectName: "Jawalat Al Horouf",
    partners: "Dubai Media Inc. - Dubai Government",
    client: "Dubai Media Inc. - Dubai Government",
    subTitle: "(In Production)",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-mobile-alt",
        icon2: null,
      },
    },
    // projectDescription: `Journeys of Letters is a multiplayer mobile party game aimed at teaching the fundamentals of the Arabic language in a fun and interactive way.`,
    challenge: `Adapting the TV program <a href="https://www.youtube.com/watch?v=fsUk5hPXiZg&t=151s" target="_blank" rel="noopener noreferrer">Al-Mufatish Fasih</a> into a multiplayer game.`,

    // approach: {
    //   text: null,
    //   points: null,
    // },
    Achievement: "",
    coverage: `UAE `,
    globalText: [
      "Journeys of Letters is a multiplayer mobile party game aimed at promoting the Arabic language & culture.",
    ],
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [jawalat1, jawalat2],
    },
    technologies: [
      { image: unity, name: "Unity" },
      { image: blender, name: "Blender" },
      // { image: autodesk, name: "Autodesk Maya", semiLarge: true },
    ],
    singleImage: ApplesOrangesMockup1,
    googlePlayUrl: {
      img: googlePlay,
      url: "https://play.google.com/store/apps/details?id=com.sparkasse.thebusinessgame&gl=US",
    },
    appStoreUrl: {
      img: AppStore,
      url: "https://apps.apple.com/eg/app/the-micro-business-game/id6443647722",
    },
    url: "",
    comisonSoon: true,
  },

  // ( 3 ) Zido world games
  {
    projectName: "Zido World Games",
    partners: "ZAD group",
    client: "ZAD group",
    subTitle: "Educational Game",
    type: {
      text: "Platform",
      icon: {
        icon1: null,
        icon2: "fas fa-mobile-alt",
      },
    },
    // projectDescription: `The Zido World curriculum is based on a set of multi-purpose educational objectives that combine faith, knowledge, behavior, and skills. Each developmental unit is linked to several specific educational objectives, with criteria and indicators for success. These objectives are ultimately integrated through a matrix of educational values ​​to shape the child's personality, reinforce their values, and develop their skills.`,
    challenge: `Building cohesive game design documents for comprehensive educational games as learning aid for k-12 curricula .`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: "K-12 KSA",
    globalText: [
      "Zido World is a Sharia compliant independent education curricula for young children.",
    ],
    horizontal: true,
    otherBenefits: null,
    technologies: [],
    carousel: {
      images: [zido_1, zido_2, zido_3],
    },
    singleImage: ApplesOrangesMockup1,
    googlePlayUrl: {
      img: googlePlay,
      url: "https://play.google.com/store/apps/details?id=com.zidoworld.kids",
    },
    appStoreUrl: {
      img: AppStore,
      url: "https://apps.apple.com/us/app/%D8%B9%D8%A7%D9%84%D9%85-%D8%B2%D9%8A%D8%AF%D9%88-zido-world/id1671489999",
    },
    url: "https://zidoworld.com/",
  },

  // ( 4 ) Secrets of The Mountains
  {
    projectName: "Secrets of The Mountains",
    partners: "Phantasm (Self Published)",
    client: "Phantasm (Self Published)",
    subTitle: "(Pre Production)",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: null,
        image: gam,
      },
    },
    projectDescription: null,
    projectDescriptionList: null,
    challenge: `Representing our culture through state of the art game experience.`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    globalText: [
      "Secrets of the Mountains is an entertainment video game built on the Saudi Fantasy series “Ard EL Jebal”.",
      "Players assume the role of Omar, on a journey to unite the seven tribes into an alliance to rally an army against Azazeel.",
    ],
    Achievement: "",
    coverage: `Global (PC & Console)`,
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: Historica,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://xd.adobe.com/view/46b8053d-4e9b-4772-a1cd-3a9f6372ab90-13eb/",
    urlGroup: {
      url: {
        url: "https://mo42ksa.com/OqqnvGa",
        name: "B2C",
        btnText: "Visit book",
      },
      url2: {
        url: "https://www.jarir.com/arabic-books-591416.html",
        name: "B2B",
        btnText: "Visit book",
      },
    },
  },
  // ( 5 ) PatRec
  {
    projectName: "PatRec",
    partners: "Holden Knight Group",
    client: "Holden Knight Group",
    subTitle: "Digital Medical Consultation Platform",

    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
      },
    },
    projectDescription: null,
    challenge: `Support vertical expansion by transforming Holden Knight’s existing medical network into a digital platform that opens a new revenue stream.`,
    coverage: "UK - MENA",
    approach: null,
    // otherBenefits: [
    //   "The software enables patients to have their full medical records in one place.",
    //   "The software offers a one stop solution for efficient communication between patients, hospitals, labs, and medical consultants.",
    // ],
    globalText: [
      "Patrec is a software that allows patients around the world to access London’s top medical professionals & hospitals.",
    ],
    technologies: [
      { image: swift, name: "Swift" },
      { image: android, name: "Android" },
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
    ],
    carousel: {
      images: [Patrec1, Patrec2],
      text: "PatRec Doctor",
    },
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://holdenknight.com/",
  },

  // ( 6 ) ABARDO
  {
    projectName: "ABARDO",
    partners: "Holden Knight Group",
    client: "Holden Knight Group",
    subTitle: "Virtual and hybrid event experiences",

    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
      },
    },
    projectDescription: ``,
    challenge: `Renovating Abardo by integrating Teams and Google Meets, and introducing APIs for B2B integrations.`,

    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: "UK",
    globalText: [
      "Abardo is one of Holden Knight Group’s companies. The app offers a unique digital event experience and is widely used for business events across the UK.",
    ],
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
      { image: node, name: "Node Js" },
    ],
    singleImage: abardo,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://abardo.com/",
  },
  // ( 7 )  Tayar
  {
    projectName: "Tayar (Roboost)",
    partners: "Roboost",
    client: "Roboost",
    subTitle: "AI-enabled delivery optimization system",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
      },
    },
    // projectDescription: `Tayar is an AI-powered, cloud-based platform that provides automated logistics and delivery management solutions for businesses, aiming to reduce costs, increase efficiency, and improve delivery speed through features like route optimization, automated dispatching, real-time fleet tracking, and AI-driven performance analysis.`,
    boldDiscription: `Top potential start up in MENA Raised $3M on a $30M valuation`,
    challenge: `Building the initial MVP to validate the concept with real customers with limited budget and timeframe.`,
    // challenge2:
    //   "Roboost is a top potential startup in MENA. Raised $3M on a $30M valuation.",
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: null,
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [
      { image: swift, name: "Swift" },
      { image: react, name: "React" },
      { image: kotlin, name: "Kotlin", withPadding: true },
      {
        image: rust,
        name: "Ruby on Rails",
        withPadding: false,
        semiLarge: true,
      },
    ],
    singleImage: roboost,
    googlePlayUrl: {
      img: googlePlay,
      url: "https://play.google.com/store/apps/details?id=com.app.tayar&hl=en",
    },
    appStoreUrl: {
      img: AppStore,
      url: "https://apps.apple.com/eg/app/roboost/id1596323271",
    },
    url: "https://roboost.ai/",
  },
  // ( 8 )  SIMTalent
  {
    projectName: "SIMTalent",
    partners: "CELEMI",
    client: "CELEMI",
    subTitle: "Digital HR Training Platform",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: null,
      },
    },
    // projectDescription: `Simtalent is a corporate training gamified content that teaches HR concepts`,
    projectDescription: ``,
    challenge: `Transforming a physical board game for corporate HR training into a fully digital, gamified platform to address the challenges of accessibility, cost, and safety during the COVID-19 pandemic.`,
    coverage:
      "SIMTalent is a corporate training solution designed to teach HR concepts through engaging gamified content. By transitioning from a physical board game to an online platform, the solution ensures global accessibility and scalability while maintaining an interactive learning experience.",
    // approach: {
    //   text: `Designing and implementing a software user experience to adopt the physical haptic board game into an online session. `,
    //   points: null,
    // },
    otherBenefits: null,
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
      { image: node, name: "Node Js" },
    ],
    carousel: {
      images: [SIMTalent1, SIMTalent2],
    },
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://simdustry.de/en/",
  },
  // ( 9 )  Apples and Oranges
  {
    projectName: "Apples and Oranges",
    partners: "CELEMI",
    client: "CELEMI",
    subTitle: "Digital Corporate Training Platform",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: null,
      },
    },
    // projectDescription: `Apples and Oranges is a haptic board game developed by the company Celemi, its purpose is to teach finance for non financial people in corporations.  environment`,
    projectDescription: ``,
    challenge: `Converting a physical board game designed to teach finance concepts to non-financial professionals into a digital platform. The goal was to overcome accessibility and cost challenges, particularly during the COVID-19 pandemic, when physical sessions were not feasible.`,
    coverage:
      "Apples and Oranges is an interactive learning tool developed by CELEMI to simplify finance education for corporate teams. The transition to a digital platform ensures accessibility, scalability, and a seamless learning experience for global users.",
    // approach: {
    //   text: `Designing and implementing a software user experience to adopt the physical haptic board game into an online session.`,
    //   points: null,
    // },
    otherBenefits: null,
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
      { image: node, name: "Node Js" },
    ],
    carousel: {
      images: [ApplesOrangesMockup1, ApplesOrangesMockup2],
    },
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://celemi.com/gamified-training-solutions/apples-oranges",
  },
  // ( 10 )  Eco Egypt
  {
    projectName: "Eco Egypt",
    partners:
      "UNDP - The Ministry of Environment in Egypt (EEAA) - Wali’s Studio",
    client:
      "UNDP - The Ministry of Environment in Egypt (EEAA) - Wali’s Studio",
    subTitle: "Digital Ecotourism and Conservation Platform",

    type: {
      text: "Website, AR experience",
      icon: {
        icon1: "fas fa-desktop",
        icon2: null,
      },
    },
    // projectDescription: `ECO EGYPT Experiences is a campaign that aims to reconnect adventurous travellers with Egypt’s countless ecological sites and protected areas.The project is a full documentation of Egyptian national parks and eco sites using Augmented Reality (AR) experience.`,
    projectDescription: ``,
    coverage:
      "Eco Egypt is a collaborative initiative to showcase Egypt's diverse natural heritage and reconnect travelers with its ecological sites. The project utilizes Augmented Reality (AR) to provide an immersive experience of Egypt’s protected areas, targeting global adventurers and conservation advocates.",
    challenge: `Building a platform that documents Egypt's ecological sites and national parks using advanced digital tools, promoting ecological conservation and sustainable tourism.`,
    // approach: {
    //   text: "Designing and implementing a software user experience to adopt the physical haptic board game into an online session.",
    //   points: null,
    // },
    otherBenefits: null,
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
    ],
    carousel: {
      images: [Eco1, Eco2],
    },
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://ecoegyptexperiences.com/",
  },

  // ( 11 )  Vatrina
  {
    projectName: "Vatrina",
    partners: "Vatrina",
    client: "Vatrina",
    subTitle: "E-Commerce (B2B) & (B2C)",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: null,
      },
    },
    projectDescription: ``,
    challenge: ``,
    challengeList: [
      "Build E-commerce platform for Vatrina to strengthen the B2C vertical in the local market.",
      "Build E-commerce platform for Vatrina to Support sales efforts for B2B export market.",
    ],
    // approach: {
    //   text: null,
    //   points: null,
    // },
    Achievement: "$1M+ in Revenue",
    coverage: ``,
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [Vatrina, Vatrina2],
    },
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
      { image: shopyfy, name: "Shopify" },
    ],
    singleImage: Vatrina,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://www.vatrina.shop/",
    urlGroup: {
      url: {
        url: "https://www.vatrina.shop/",
        name: "B2C",
      },
      url2: {
        url: "https://mous221.wixsite.com/mysite-1",
        name: "B2B",
      },
    },
  },
  // ( 12 )  ZAGG
  {
    projectName: "ZAGG",
    partners: "ZAGG ",
    client: "ZAGG ",
    subTitle: "E-Commerce",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: null,
      },
    },
    // projectDescription: `ZAGG started in Utah with a simple idea that quickly grew into a movement: empower people to do more with their mobile devices—fearlessly. Our founders recognised that these tiny screens in our pockets were changing the way we connect with friends, family, and the world. But there was one big challenge: people wanted to explore all that technology offered without worrying about scratches, cracks, or damage. ZAGG rose to that challenge by creating innovative protective solutions that let life happen, minus the anxiety.`,
    challenge: `Supporting and helping zagg create innovative and customized pages with their e-commerce platform.`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: `Italy-UK-Germany-France-Ireland-Sweden-UAE-KSA`,
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
      { image: bigCom, name: "BIGCOMMERCE", large: true },
    ],
    singleImage: zagg,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://eu.zagg.com/",
  },
  // ( 13 )  Saqaya
  {
    projectName: "Saqaya",
    partners: "Saqaya ",
    client: "Saqaya ",
    subTitle: null,
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
      },
    },
    projectDescription: null,
    challenge: `Building Saqaya's landing page.`,
    Squad: null, // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: `UK- EGYPT`,
    globalText: [
      "SAQAYA is a company that offers Nearshore product engineering services through Egyptian talent.",
    ],
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
    ],
    singleImage: saqaya,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://saqaya.com/",
  },

  // ( 14 )  Pacific mining
  {
    projectName: "Pacific Mining",
    partners: "Al Safy Group",
    client: "Al Safy Group",
    subTitle: "Raw Material Mining",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "",
      },
    },
    projectDescription: null,
    challenge: `Develop a software tool to Help ALSAFY group audit their mining processes and analyze scale and opportunities for mining sites.`,
    Squad: null, // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: `USA`,
    globalText: ["AL SAFY is a family owned conglomerate based in Cairo."],
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
    ],
    singleImage: SAFY,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://alsafygroup.com/?lang=ar",
  },
  // ( 15 )  ZAGG
  {
    projectName: "ZAGG",
    partners: "ZAGG ",
    client: "ZAGG ",
    subTitle: "Staffing",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: null,
      },
    },
    projectDescription: null,
    challenge: `Acquiring and incubating the right talent to support zagg’s EU team to grow their presence and sales in EMEA`,
    Squad:
      "Graphic designer, Content director, Full stack software engineer, Amazon Marketplace Specialist, 2x Amazon account manager, Data entry/Product listing",
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: `Italy-UK-Germany-France-Ireland-Sweden-UAE-KSA`,
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
      { image: bigCom, name: "BIGCOMMERCE", large: true },
    ],
    singleImage: zagg,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://eu.zagg.com/",
  },
  // ( 16 )  AI Sports Data collection
  {
    projectName: "AI Sports Data collection",
    partners: "BRENTFORD - SAQAYA ",
    client: "BRENTFORD - SAQAYA ",
    subTitle: "Brentford player data set and performance prediction tool",
    type: null,
    projectDescription: ``,
    challenge: `Acquiring and incubating the right talent to build the technology that gathers players information from different datasets in real time to predict player performance and visualize data.`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: `Brentford football team - Brentford Rugby & more`,
    Squad: "Data Scientist, Back-end engineer, Front-end engineer",
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: aiSports,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: null,
  },
  // ( 17 ) Savvy broker
  {
    projectName: "Savvy broker",
    partners: "Beach landing - SAQAYA",
    client: "Beach landing - SAQAYA",
    subTitle: "Real estate",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
      },
    },
    projectDescription: ``,
    challenge: `Acquiring and incubating the right talent to develop a predictive analytics platform for real-time decision-making in real estate brokerage.`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: `USA`,
    Squad:
      "UI/UX Designer, Senior Back-end engineer, Back-end engineer, 2x Senior Front-end engineer, QC engineer, Scrum master, Product owner",
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [
      { image: laravel, name: "Laravel" },
      { image: react, name: "React" },
    ],
    singleImage: Savvy,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://savvy-broker.com/",
  },

  // ( 18 ) Saydaly
  {
    projectName: "Saydaly",
    partners: null,
    client: null,
    subTitle: "Pharmaceutical",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
      },
    },
    originalUsage:
      "Marketplace for healthcare, originally built as a solution to ease medicine delivery for the Egyptian Market.",
    globalText: [
      "The founders are offering the technology for sale since the disband of the company.",
    ],
    howWorks:
      "Users search for the medicine they need, add items to cart and order. On the pharmacy side the order propagates to the pharmacies sequentially until a pharmacy accept the order.",
    useCases:
      "Online pharmacy marketplace, Medicine delivery platform, White-label solution for pharmacies, Hospital and clinic pharmacy fulfillment.",
    projectDescription: ``,
    challenge: null,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: null,
    Squad: null,
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: Saydaly,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://www.facebook.com/people/SAYDALY/100068409214427/",
  },

  // ( 19 ) Noopets
  {
    projectName: "Noopets",
    partners: null,
    client: null,
    subTitle: "Pet Delivery",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
      },
    },
    originalUsage:
      "Carpooling app, originally built for french startup to offer a way to transfer pets from one place to another safely.",
    globalText: [
      "The founders are now offering the technology for sale since new regulations have been instituted by the french government on pet transfer which obsolete the business case.",
    ],
    howWorks:
      "Similar to uber the app offers a bridge between riders and pet owners.",
    useCases: "Pet transportation services, Veterinary clinics.",
    projectDescription: ``,
    challenge: null,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: null,
    Squad: null,
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: trips_large,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "http://www.noopets.com/",
  },
  // ( 20 ) MR.B
  {
    projectName: "MR. B",
    partners: null,
    client: null,
    subTitle: "Fleet Management",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
      },
    },
    originalUsage:
      "Helps restaurants deliver to customers by matching each order with drivers nearby.",
    globalText: [],
    howWorks:
      "Vendors post deliveries, riders accept them, and customers track them in real time. Faster deliveries, lower costs, and more orders; without the headache of managing couriers.",
    useCases:
      "Restaurant food delivery, Cloud kitchen delivery operations, Last-mile delivery for local retailers.",
    projectDescription: ``,
    challenge: null,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    coverage: null,
    Squad: null,
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: mrb_large,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: null,
  },
  // (21 ) Seeds of Hope
  {
    projectName: "Seeds of Hope (بذور الأمل)",
    partners: "Potential Humanitarian Aid & Relief Centers",
    client: "",
    potentialClient: "Potential Humanitarian Aid & Relief Centers",
    subTitle: "(Concept)",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        image: gam,
      },
    },
    projectDescription: null,
    projectDescriptionList: null,
    challenge: `Creating a narrative-driven simulation game to promote volunteering culture in GCC region.`,
    globalText: [
      "Seeds of Hope is a simulation and strategy game with RPG elements, following Salem, a young volunteer helping the village of Yaqoura overcome humanitarian crises. Players work to build a thriving community through diverse programs, addressing socio-economic, climatic, and social challenges, aligned with the UN SDGs.",
      "Inspired by Eiyuden Chronicles Rising and Stardew Valley, the game targets console players (12+) who enjoy strategy and RPGs.",
    ],
    Objective:
      "Raise humanitarian awareness and inspire real-world support through impactful gameplay.",
    // approach: {
    //   text: "",
    //   points: null,
    // },
    Achievement: null,
    coverage: `Global (Console - PC - Mobile)`,
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: seeds_of_hope,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: null,
    urlGroup: null,
  },
  // ( 22 ) Graveler
  {
    projectName: "Graveler",
    partners: "University of Tubingen",
    client: "University of Tubingen",
    subTitle: "Virtual University Campus",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: null,
      },
    },
    projectDescription: ``,
    challenge: `A web platform that aims to increase engagement and spread global awareness through a digital social tool that represent the university campus.`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    Achievement: "",
    coverage: `UOT students `,
    horizontal: false,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: Graveler,
    graveler: true,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "https://xd.adobe.com/view/46b8053d-4e9b-4772-a1cd-3a9f6372ab90-13eb/",
  },
  // ( 23 ) Historica
  {
    projectName: "Historica",
    partners: "Governmental Entities - Educational Institutions",
    client: "",
    potentialClient: "Governmental Entities - Educational Institutions",
    subTitle: "(Pre Production)",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-mobile-alt",
        icon2: null,
      },
    },
    projectDescription: ``,
    challenge: `Transforming history school curriculum into an engaging storytelling game experience.`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    Achievement: "",
    coverage: `K-12, History curricula`,
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: HistoricaR,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: "",
  },

  // ( 24 ) PeaceKeepers
  {
    projectName: "PeaceKeepers",
    partners: "NGOs and International Law bodies",
    client: "",
    potentialClient: "NGOs and International Law bodies",
    subTitle: "(Concept)",
    type: {
      text: "Platform",
      icon: {
        icon1: "fas fa-desktop",
        icon2: "fas fa-mobile-alt",
        image: gam,
      },
    },
    projectDescription: null,
    projectDescriptionList: null,
    challenge: `Educating players on International Humanitarian Law through an engaging game experience.`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    Achievement: null,
    coverage: `Global (Mobile-first, scalable to multi-platform)`,

    globalText: [
      "Peacekeepers is a story-driven game following Alex, Sarah, and Sam, volunteers in a war-torn city. Players investigate war crimes and carry out humanitarian missions based on the Geneva Conventions through interactive narrative, puzzles, and turn-based tactics.",
    ],
    Objective:
      "Raise awareness of humanitarian law and ethical responsibility in war and peace.",
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: peacekeepers,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: null,
    urlGroup: null,
  },
  // ( 25 ) Rabbit Rider
  {
    projectName: "Rabbit Rider",
    partners: "Q-Commerce",
    client: "",
    potentialClient: "Q-Commerce",
    subTitle: "(Concept)",
    type: {
      text: "Platform",
      icon: {
        icon1: "",
        icon2: "fas fa-mobile-alt",
        // image: gam,
      },
    },
    projectDescription: null,
    projectDescriptionList: null,
    challenge: `Turning the delivery wait into an engaging branded experience.`,
    // approach: {
    //   text: null,
    //   points: null,
    // },
    globalText: [
      "Rabbit Rider is a fast-paced delivery game embedded in a Q-commerce platform, where players control a driver to optimize routes and avoid traffic during their waiting time on the app.",
    ],
    Objective:
      "Monetize waiting time, strengthen brand connection by spotlighting drivers as heroes, and drive retention through play-to-earn rewards and loyalty loops.",
    Achievement: null,
    // coverage: `Saudi Arabia (Riyadh)`,
    coverage: null,
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: rabbit,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: null,
    urlGroup: null,
  },
  //  ( 26 ) Power your connection
  {
    projectName: "Power your connection",
    partners: "Retail stores",
    client: "",
    potentialClient: "Retail stores",
    subTitle: "(Concept - VR Experience)",
    type: {
      text: "Platform",
      icon: {
        icon1: "",
        icon2: "fas fa-mobile-alt",
        // image: gam,
      },
    },
    projectDescription: null,
    projectDescriptionList: null,
    challenge: `Driving in-store foot traffic and product conversion through a full-funnel gamified activation.`,
    // approach: {
    //   text: `Engage gamers and extreme sports fans, support activations, and capture trackable consumer insights.`,
    //   points: null,
    // },
    Achievement: null,
    coverage: null,

    globalText: [
      "Power Your Connection is an AR mobile game where players help Luke find a hidden virtual power bank in-store to unlock a redeemable reward code, share #PowerYourConnection, and claim a free item.",
    ],
    Objective:
      "Increase in-store visits, promote products, and drive conversion through gamified rewards and social sharing.",
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: power,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: null,
    urlGroup: null,
  },
  //  ( 27 ) Wheels n Wings
  {
    projectName: "Wheels n Wings",
    partners: "FMCGS",
    client: "",
    potentialClient: "FMCGS",
    subTitle: "(Concept)",
    type: {
      text: "Platform",
      icon: {
        icon1: "",
        icon2: "fas fa-mobile-alt",
        // image: gam,
      },
    },
    projectDescription: null,
    projectDescriptionList: null,
    challenge: `Utilise games as advertising tools`,
    // approach: {
    //   text: `Engage gamers and extreme sports fans, support activations, and capture trackable consumer insights.`,
    //   points: null,
    // },
    Achievement: null,
    coverage: `Web-based`,

    globalText: [
      "Wheels and Wings is a short web adventure where Salma, an Egyptian off-road biker, races across rough terrain, collect Energy Drinks to unlock wings and speed boosts and finish a 30-second level to win.",
    ],
    Objective:
      "Engage gamers and extreme sports fans, support activations, and capture trackable consumer insights.",
    horizontal: true,
    otherBenefits: null,
    carousel: {
      images: [],
    },
    technologies: [],
    singleImage: Wheels,
    googlePlayUrl: null,
    appStoreUrl: null,
    url: null,
    urlGroup: null,
  },
];

export const impactProjects = [
  // 1
  {
    projectName: "The Savings Game",
    partners:
      "Deutsche Sparkassenstiftung für Internationale Kooperation; DSIK",
    type: {
      text: "Educational Mobile Game",
      icon: {
        icon1: null,
        icon2: "fas fa-mobile-alt",
      },
    },
    projectDescription: null,
    challenge: `The organisation is struggling with the limitation of a closed room gamified training that teaches how to improve one's quality of life and manage finances.`,
    approach: {
      text: `Designing a single player simulation game that injects the learning objectives into an interactive experience.`,
      points: [
        "Empowering on-ground training by the extra activity that is available to the audience.",
        "Extending and strengthening the post-training connection with the audience",
        "Reaching a wider audience and making DSIK’s learning objectives available to a broader target group.",
      ],
    },
    otherBenefits: null,
    technologies: [
      { image: unity, name: "Unity" },
      { image: blender, name: "Blender" },
      { image: autodesk, name: "Autodesk Maya", semiLarge: true },
    ],
    carousel: {
      images: [Savings1, Savings2],
    },
    googlePlayUrl: {
      img: googlePlay,
      url: "https://play.google.com/store/apps/details?id=de.sparkasse.savingsgame&gl=US",
    },
    appStoreUrl: {
      img: AppStore,
      url: "https://apps.apple.com/eg/app/the-savings-game/id1583366017",
    },
    url: null,
  },
  // 2
  {
    projectName: "The Micro Business Game",
    partners:
      "Deutsche Sparkassenstiftung für Internationale Kooperation; DSIK",
    subTitle: "Manage your juicery shop",
    type: {
      text: "Educational Mobile Game",
      icon: {
        icon1: null,
        icon2: "fas fa-mobile-alt",
      },
    },
    projectDescription: null,
    challenge: `The organisation is struggling with the limitation of a closed room gamified training that teaches how to run a micro business.`,
    approach: {
      text: `Designing a single player simulation game that injects the learning objectives into an interactive experience.`,
      points: [
        "Empowering on-ground training by the extra activity that is available to the audience.",
        "Extending and strengthening the post-training connection with the audience",
        "Reaching a wider audience and making DSIK’s learning objectives available to a broader target group.",
      ],
    },
    otherBenefits: null,
    technologies: [
      { image: unity, name: "Unity" },
      { image: blender, name: "Blender" },
      { image: autodesk, name: "Autodesk Maya", semiLarge: true },
    ],
    carousel: {
      images: [Microbusiness1, Microbusiness2],
    },
    googlePlayUrl: {
      img: googlePlay,
      url: "https://play.google.com/store/apps/details?id=de.sparkasse.savingsgame&gl=US",
    },
    appStoreUrl: {
      img: AppStore,
      url: "https://apps.apple.com/eg/app/the-savings-game/id1583366017",
    },
    url: "https://holdenknight.com/",
  },
];
